/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle04Icon16Solid = forwardRef('NumberCircle04Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.148-5.983V7.378H8.656v1.639H6.521L9.594 4.01H7.922L4.995 8.825v1.412h3.661V12h1.492v-1.763h1.062v-1.22h-1.062Z" })));
});
